// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminOrderSets = (client) => ({
    /**
     * `GET /admin/order-sets`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListOrderSets
     * @source packages/modules/b2c-core/src/api/admin/order-sets/route.ts
     */
    list: (query, headers) => client.fetch("/admin/order-sets", { method: "GET", query, headers }),
    /**
     * `GET /admin/order-sets/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetOrderSet
     * @source packages/modules/b2c-core/src/api/admin/order-sets/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/order-sets/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=order-sets.js.map